import { get } from 'lodash-es';

/**
 * Checks if can generate lease payments
 * @param {object} vehicle
 * @returns {boolean}
 */
export function isLeasePaymentsEligible(vehicle) {
  return !!get(vehicle, 'prices.advertisedPrice');
}
